module.exports = "/_next/static/media/69f53b2e869ff9dd6fa2f57824631d76.png";